module.exports = __webpack_public_path__ + "static/media/wrench.d9b763bc.svg";